<template>
  <footer class="main-footer">
    <strong>
      <span>&nbsp;</span>
    </strong>
    <div class="float-right d-sm-inline-block">
      <b>build</b>
      <span>:&nbsp;{{build}}</span>
    </div>
  </footer>
</template>
<script>

import {version} from '../../../../package.json';
import {DateTime} from 'luxon';

export default {
  data() {
    return {
      version: version,
      currentYear: DateTime.now().toFormat('y'),
    }
  },
  computed: {
    build() {
      return process.env.VUE_APP_GIT_REF;
    },
  }
}

</script>
<style></style>
